<template>
  <div style="width: 98%;margin-right: 1%;display: inline-block;">
    <el-card shadow="never" class="text item" :body-style="{ padding: '0px 12px','font-size':'12px',height:'39px',display:'flex'}">
        <el-row :gutter="20" style="display: flex;align-items: center;flex: 1">
          <el-col :span="5" style="width: 360px">
            <div class="grid-content bg-purple">
              数据异动
            </div>
          </el-col>
          <el-col :span="4" offset="16">
            <div class="grid-content bg-purple">
            <el-button type="primary" plain size="small" @click="listenDisCount">Skinport扫货机器人</el-button>
          </div>
          </el-col>
        </el-row>
      </el-card>
    <div style="height: 260px;overflow: auto"  v-if="!loading">
      <el-card
        shadow="hover"
        v-for="(message, index) in messages"
        :key="index"
        class="text item"
        :body-style="{ padding: '0 12px', fontSize: '12px' }"
        style="margin: 6px 0; height: 48px; border-radius: 8px; border: 1px solid #f0f2f5; transition: all 0.3s;"
      >
        <el-row
          :gutter="16"
          style="display: flex; align-items: center; height: 48px;"
        >
          <!-- 时间列：优化颜色和间距 -->
          <el-col :span="4">
            <div style="display: flex; align-items: center;">
              <!-- 根据异动类型区分颜色点 -->
              <span class="ant-badge ant-badge-status ant-badge-not-a-wrapper" style="margin-right: 6px;">
          <span
            class="ant-badge-status-dot"
            :class="getDotClass(message.changeMsg)"
          ></span>
        </span>
              <span style="color: #666; font-size: 11px;">{{ message.updateTime }}</span>
            </div>
          </el-col>

          <!-- 名称列：增加高亮和间距 -->
          <el-col :span="8">
            <div style="display: flex; align-items: center; padding-left: 8px;">
              <div style="color: #2d3748; font-size: 12px; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                {{ message.cnName }}
              </div>
            </div>
          </el-col>

          <!-- 异动信息列：优化排版和高亮 -->
          <el-col :span="12">
            <div style="display: flex; align-items: center; flex-wrap: nowrap; overflow: hidden; text-overflow: ellipsis;">
              <!-- 异动类型标签化（提取方括号内容） -->
              <div style="min-width: 80px;">
                <el-tag
                  effect="plain"
                  size="mini"
                  :type="getTagType(message.changeMsg)"
                  style="margin-right: 8px; padding: 2px 6px; height: 20px; line-height: 16px;"
                >
                  {{ extractChangeType(message.changeMsg) }}
                </el-tag>
              </div>
              <!-- 异动详情：移除方括号，高亮百分比 -->
              <div style="color: #4a5568; font-size: 11px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                <span v-html="formatChangeMsg(message.changeMsg)"></span>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <div style="height: 260px;overflow: auto"  v-else>
      <el-skeleton  style="margin-top: 24px" :rows="6" animated />
    </div>

    <el-dialog size="mini" :visible.sync="listenDialog" width="480px">
      <el-tabs v-model="activeTab" type="border-card">
        <el-tab-pane label="服务介绍" name="first">
          <h3 style="text-align: center;margin-top: 8px" class="plan-name">实时扫货机器人</h3>
          <div style="display: flex;align-items: center">
            <ul style="list-style: none;gap:.75rem" class="plan">
              <li style="align-items: center;display: flex;">
                <svg style="color: #22c55e;margin-right: 12px" data-v-e8d572f6="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     aria-hidden="true" role="img" class="icon text-green-500 w-6 h-6" width="1em" height="1em"
                     viewBox="0 0 24 24">
                  <path fill="currentColor"
                        d="m10.6 13.8l-2.15-2.15q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275zM12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"></path>
                </svg>
                <span style="line-height: 1.75rem;font-weight: 100">
                  收费方式:  285 ￥ / 月
            </span>
              </li>
              <li style="align-items: center;display: flex;">
                <svg style="color: #22c55e;margin-right: 12px" data-v-e8d572f6="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     aria-hidden="true" role="img" class="icon text-green-500 w-6 h-6" width="1em" height="1em"
                     viewBox="0 0 24 24">
                  <path fill="currentColor"
                        d="m10.6 13.8l-2.15-2.15q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275zM12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"></path>
                </svg>
                <span style="line-height: 1.75rem;font-weight: 100">
                    7*24 实时邮件推送
                  </span>
              </li>
              <li style="align-items: center;display: flex;">
                <svg style="color: #22c55e;margin-right: 12px" data-v-e8d572f6="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     aria-hidden="true" role="img" class="icon text-green-500 w-6 h-6" width="1em" height="1em"
                     viewBox="0 0 24 24">
                  <path fill="currentColor"
                        d="m10.6 13.8l-2.15-2.15q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275zM12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"></path>
                </svg>
                <span style="line-height: 1.75rem;font-weight: 100">
                最快一单回本
              </span>
              </li>
              <li style="align-items: center;display: flex;">
                <svg style="color: #22c55e;margin-right: 12px" data-v-e8d572f6="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     aria-hidden="true" role="img" class="icon text-green-500 w-6 h-6" width="1em" height="1em"
                     viewBox="0 0 24 24">
                  <path fill="currentColor"
                        d="m10.6 13.8l-2.15-2.15q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275zM12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"></path>
                </svg>
                <span style="line-height: 1.75rem;font-weight: 100">
                可靠的比价信息与求购排序
              </span>
              </li>
            </ul>
            <img style="width: 168px;margin-left: 12px" src="../../../static/imgs/Skinport_bot.jpg"/>
          </div>
          <div style="text-align: center">
            <el-button style="min-width: 120px" type="primary" round disabled>  进群联系群主开通 </el-button>
          </div>
        </el-tab-pane>
      </el-tabs>


    </el-dialog>
  </div>
</template>

<script>
import {unusualChange} from "../../api/api";

export default {
  name:'UnusualChange',
  data() {
    return {
      searchForm:{
        limit:10,
        offset:1,
        total:0
      },
      socket: null,
      messages: [],
      reconnectInterval: null,
      isReconnecting: false, // 新增一个标志位
      listenDialog: false,
      activeTab:'first',
      alertItemData:[],
      loading: false
    };
  },
  created() {
    this.loading = true
    unusualChange().then(json=>{
      if (json.data.flag == 'T'){
        this.messages = json.data.data || []
      }
    }).finally(_=>{
      this.loading = false
    })
  },
  beforeDestroy() {
  },
  methods: {
    // 提取方括号中的异动类型（如：[价格异动] → 价格异动）
    extractChangeType(changeMsg) {
      const reg = /\[([^)]+)\]/; // 匹配 [xxx] 格式
      const match = changeMsg.match(reg);
      return match ? match[1] : '异动';
    },

    // 根据异动类型获取标签类型（danger/success/primary）
    getTagType(changeMsg) {
      if (changeMsg.includes('价格')) return 'danger';
      if (changeMsg.includes('在售数量')) return 'success';
      if (changeMsg.includes('求购数量')) return 'primary';
      return 'info'; // 默认类型
    },

    // 根据异动类型获取状态点颜色
    getDotClass(changeMsg) {
      if (changeMsg.includes('价格')) return 'ant-badge-status-red';
      if (changeMsg.includes('在售数量')) return 'ant-badge-status-green';
      if (changeMsg.includes('求购数量')) return 'ant-badge-status-blue';
      return 'ant-badge-status-gray'; // 默认颜色
    },

    // 格式化异动信息：移除方括号，高亮百分比
    formatChangeMsg(msg) {
      // 1. 移除 [xxx] 前缀
      const pureMsg = msg.replace(/\[([^)]+)\]\s*/, '');
      // 2. 高亮百分比（增长红色，下降绿色）
      return pureMsg.replace(
        /\(([-+]?\d+\.\d+)%\)/g,
        (match, percent) => {
          const color = Number(percent) > 0 ? '#e53e3e' : '#38a169';
          return `<span style="color: ${color}; font-weight: 600;">(${percent}%)</span>`;
        }
      );
    },
    listenDisCount(){
      this.listenDialog = true
    },
    parseChangeMsg(message) {
      const rawStr = message.changeMsg;
      const items = rawStr.split(', ');

      return items.map(item => {
        const [label, valueStr] = item.split(': ');
        const [oldValue, newValue] = valueStr.split(' -> ');

        // 转换为数值进行比较（处理数字和价格类型）
        const oldNum = parseFloat(oldValue);
        const newNum = parseFloat(newValue);

        // 新增不变的判断条件
        const isRise = newNum > oldNum;
        const isFall = newNum < oldNum;
        // 不变的情况：!isRise && !isFall

        return { label, oldValue, newValue, isRise, isFall };
      });
    }
  },
};
</script>

<style>
/* 添加一些基本样式 */
h1 {
  font-size: 2em;
}

.ant-badge {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  position: relative;
  display: inline-block;
  line-height: 1;
}

.ant-badge-status-dot {
  background: #1890ff;
  position: relative;
  top: -1px;
  display: inline-block;
  width: 6px;
  height: 6px;
  vertical-align: middle;
  border-radius: 50%;
}

/* 优化hover效果 */
.text.item:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  border-color: #e8f4f8;
}

/* 调整状态点大小 */
.ant-badge-status-dot {
  width: 8px !important;
  height: 8px !important;
}

/* 优化标签样式 */
.el-tag--mini {
  border-radius: 4px !important;
  font-size: 11px !important;
}

/* 防止名称过长溢出 */
.el-col-8 {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/ui/UnusualChange/UnusualChange.vue